module.exports = __webpack_public_path__ + "static/media/5_hall_interior_back.ed5bc332.jpg";